export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./chevron-left.vue?vue&type=template&id=1e3cd3a4&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/icons/chevron-left.vue?vue&type=template&id=1e3cd3a4&
// module id = 1164
// module chunks = 0